import React from 'react';

interface DialogActionsProps {
  children: React.ReactNode;
  className?: string;
}

export const DialogActions: React.FC<DialogActionsProps> = ({ children, className = '' }) => {
  const items = React.Children.toArray(children).filter(Boolean);
  const justify = items.length === 1 ? 'justify-center' : 'justify-between';

  return <div className={`flex ${justify} mt-5 gap-[30px] ${className}`}>{items}</div>;
};
